module.exports = __webpack_public_path__ + "static/img/toHaiDian.d1e6d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/toHaiDian.png
// module id = i2I0
// module chunks = 0